import { $getSelectionStyleValueForProperty } from '@lexical/selection';
import { $getSelection, $isRangeSelection } from 'lexical';
import * as Constants from 'const';
import { FontPluginStyle } from '../style';

export function $getCharStyle(): Constants.CharStyle[] {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return [];
  }

  const result: Constants.CharStyle[] = [];

  const style = $getSelectionStyleValueForProperty(selection, FontPluginStyle.FONT_STYLE);
  if (style === Constants.CharStyleValue.ITALIC) {
    result.push(Constants.CharStyle.ITALIC);
  }

  const weight = $getSelectionStyleValueForProperty(selection, FontPluginStyle.FONT_WEIGHT);
  if (weight === Constants.CharStyleValue.BOLD) {
    result.push(Constants.CharStyle.BOLD);
  }

  if (selection.hasFormat('underline')) {
    result.push(Constants.CharStyle.UNDERLINE);
  }

  return result;
}
